import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import { compareValues } from 'utils/sorting';

import DashboardMetricsApi from 'apis/DashboardMetrices';

import ListItem from './ListItem';

const ASC = 'ascending';
const DESC = 'descending';


const sorting = {
  [ASC]: {
    order: 'ascending',
    icon: 'sort-down'
  },
  [DESC]: {
    order: 'descending',
    icon: 'sort-up'
  }
}

class ListMetrices extends Component {
  constructor() {
    super();
    this.state = {
      title: '',
      records: [],
      sortOrder: sorting['ascending'],
      isVisible: false,
      dashboardConfig: {},
      sortKey: 'rank'
    };
  }

  componentDidMount = () => {
    this.fetchMetricData();
  }

  fetchMetricData = () => {
    const { id } = this.props;

    DashboardMetricsApi.getDetails(id).then(({ data }) => {
      const { title, dashboard_config, record_list } = data;
      const { component_config, record_config } = dashboard_config;

      const sortKey = record_config.type === 'total' ? 'value' : 'rank';

      this.setState({
        title,
        sortKey,
        records: record_list && record_list.sort(compareValues(sortKey, component_config.order)),
        sortOrder: component_config ? sorting[component_config.order] : sorting.descending,
        dashboardConfig: dashboard_config
      });
    }).catch(console.log)
  }

  changeSortOrder = (order) => {
    const { sortKey } = this.state;
    let records = [...this.state.records];
    let nextOrder = order === ASC ? DESC : ASC;

    records.sort(compareValues(sortKey, nextOrder))

    this.setState({
      records,
      sortOrder: sorting[nextOrder]
    });
  }

  generateListItems = () => {
    const { records, dashboardConfig, title } = this.state;
    const { record_config: recordConfig } = dashboardConfig;

    return records && records.map((record, idx) => {
      const value = recordConfig.type === 'total' ? record.value : record.rank;

      return <ListItem
        key={idx}
        id={record.options ? record.options.parent_id : record.id}
        title={record.title}
        rank={record.rank} value={value}
        listTitle={title}
      />
    })
  }

  render() {
    const { sortOrder, title } = this.state;
    const { id } = this.props;

    return (
      <Fragment>
        <div className="p-3 w-100 d-flex flex-column justify-content-between" style={{ height: 'inherit' }}>
          <div className="metrics-header d-flex flex-row justify-content-between">
            <div>{title}</div>
            <div className="cursor-pointer" onClick={() => this.props.toggleMetricsConfig({ id, title, type: 'list' })} >
              <FontAwesomeIcon icon="cog" />
            </div>
          </div>
          <div className="metrics-body list-content mt-2 h-100">
            <ul className="list-group list-group-flush">
              {this.generateListItems()}
            </ul>
          </div>
          <div className="sort" onClick={() => this.changeSortOrder(sortOrder.order)}>
            {sortOrder.order}
            <FontAwesomeIcon icon={sortOrder.icon} className="ml-1" />
          </div>
        </div >
      </Fragment>
    );
  }
}

ListMetrices.propTypes = {
  id: PropTypes.number.isRequired,
  saveMetricConfig: PropTypes.func.isRequired,
  toggleMetricsConfig: PropTypes.func.isRequired
};

export default ListMetrices;



// WEBPACK FOOTER //
// ./src/components/dashboard/list/index.js